import type { APIMe, LoginAPI, UserCredentials } from '@jojotique/server'
import { fexios } from '@utils/fexios.ts'
import { getApplicationId } from '@utils/env'
import { removeLocalData } from '@utils/storage.ts'

export const passwordLogin = (credentials: UserCredentials): Promise<LoginAPI> => {
  return new Promise<LoginAPI>((resolve, reject) => {
    fexios
      .post<LoginAPI>('/login', credentials)
      .then((response) => {
        if (response.ok) {
          resolve(response.data)
          return
        }

        reject(response.data.message ?? 'Erreur inconnue lors de la connexion')
      })
      .catch((error) => {
        reject(`Erreur lors de la connexion: ${error}`)
      })
  })
}

export const checkCASTicket = (ticket: string): Promise<LoginAPI> => {
  return new Promise<LoginAPI>((resolve, reject) => {
    const url = new URL(window.location.href)
    url.searchParams.delete('ticket')

    fexios
      .post<LoginAPI>('/cas', {
        ticket,
        service: url.toString(),
      })
      .then((response) => {
        if (response.ok) {
          resolve(response.data)
          return
        }

        reject(response.data.message ?? 'Erreur inconnue lors de la connexion')
      })
      .catch((error) => {
        reject(`Erreur lors de la connexion: ${error}`)
      })
  })
}

export const loadMe = (): Promise<APIMe | null> => {
  return new Promise<APIMe | null>((resolve, reject) => {
    fexios
      .get<APIMe | null>('/me', {
        credentials: 'include',
        headers: { 'x-application-id': getApplicationId() },
      })
      .then((response) => {
        if (response.ok) {
          resolve(response.data)
          return
        }

        resolve(null)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export const testMe = (): Promise<void> => {
  return new Promise<void>((resolve, reject) => {
    fexios
      .get<null>('/me', {
        credentials: 'include',
        headers: { 'x-application-id': getApplicationId() },
      })
      .then((response) => {
        if (response.ok) {
          resolve()
          return
        }

        removeLocalData('me')
        reject(new Error(response.data.message))
      })
      .catch((error) => {
        reject(error)
      })
  })
}
